import React from 'react';
import { useProductAssets, Direction } from '../../hooks/useProductAssets';
import { ViewProduct } from '../../models/ViewProduct.model';
import { useRecoilValue } from 'recoil';
import { isMobileState } from '../../recoil/selectors';
import { useProductSelection } from '../../hooks/useProductSelection';
import { SelectionType } from '../../enums/SelectionType.enum';
import { DivButton } from '../../root/components/DivButton';
import { Color } from '../../enums/Color.enum';
import { useLanderControls } from '../LanderContext';
import classnames from 'classnames';
import styles from './ShopAllColors.module.scss';

export const ShopAllColors: React.FC<{ product: ViewProduct }> = ({ product }) => {
  const isMobile = useRecoilValue(isMobileState);
  const photos = useProductAssets(product);
  const filteredMannequinPhotos = photos.mannequinPhotos.filter(({ direction }) => direction === Direction.Front);
  const { scrollToProductSection } = useLanderControls();
  const { setHandle, setColor: setRecoilColor } = useProductSelection(SelectionType.ProductSection, undefined, product.handle);
  const photoElements = filteredMannequinPhotos;
  const title = photoElements.length > 3 ? 'A color for every mood' : 'Shop all colors';

  const setColor = (color: Color | undefined) => {
    setHandle(product.handle);
    setRecoilColor(color);
  };

  if (photoElements.length < 2) {
    return <></>;
  }

  return (
    <>
      <div className={styles.title}>{title}</div>
      <div
        style={isMobile ? {} : { maxWidth: getMaxWidthByLength(photoElements.length) }}
        className={
          isMobile
            ? styles.shopAllColors
            : classnames(styles.shopAllColors, { [styles.wrap]: photoElements.length > 6 }, { [styles.wrapExtended]: photoElements.length > 8 })
        }
      >
        {photoElements.map((photo, i) => {
          return (
            <DivButton
              key={i}
              onClick={() => {
                setColor(photo.color);
                scrollToProductSection();
              }}
              label={`Select ${product.title} in color ${photo.color}`}
            >
              <img src={photo.src} alt={photo.color} />
              <div>{photo.color}</div>
            </DivButton>
          );
        })}
      </div>
    </>
  );
};

const getMaxWidthByLength = (elementLength: number) => {
  switch (true) {
    case elementLength > 8:
      return 1500;
      break;
    case elementLength > 6:
      return 1200;
      break;
    default:
      return elementLength * 288;
  }
};

export default ShopAllColors;
